/**
 * Purpose: Theme registry — maps theme IDs to their definitions.
 * Owns: Theme lookup, default theme selection, theme listing for pack selection.
 * Notes: New packs (Date Night, After Dark, etc.) register their themes here.
 *        The classroom theme is the default for the Family Road Trip pack.
 */

import type { Theme } from '../types/theme';
import { classroomTheme } from './classroom';

/** Registry of all available themes, keyed by theme ID. */
const THEME_REGISTRY: Record<string, Theme> = {
  classroom: classroomTheme,
};

/** The theme used when no pack-specific theme is specified. */
export const DEFAULT_THEME_ID = 'classroom';

/** Look up a theme by its ID. Falls back to the default if not found. */
export function getTheme(themeId: string): Theme {
  return THEME_REGISTRY[themeId] ?? THEME_REGISTRY[DEFAULT_THEME_ID];
}

/** Get a list of all registered themes (for settings / debug). */
export function getAllThemes(): Theme[] {
  return Object.values(THEME_REGISTRY);
}
